import { reviews } from '@/mocks/appData';

export default function ReviewSection() {
  return (
    <section className="py-16 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1280px] mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            用户真实评价
          </h2>
          <p className="text-sm text-foreground-600 max-w-xl mx-auto">
            来自全球用户的真实反馈，CPP App 赢得了广泛信赖
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {reviews.map((review) => (
            <div
              key={review.id}
              className="p-6 rounded-2xl bg-background-100 border border-background-200/70"
            >
              <div className="flex items-center gap-3 mb-4">
                <img
                  src={review.avatar}
                  alt={review.name}
                  className="w-10 h-10 rounded-full object-cover"
                />
                <div>
                  <div className="text-sm font-medium text-foreground-800">{review.name}</div>
                  <div className="text-xs text-foreground-500">{review.date}</div>
                </div>
              </div>
              <div className="flex items-center gap-0.5 mb-3">
                {Array.from({ length: 5 }).map((_, i) => (
                  <i
                    key={i}
                    className={`text-xs ${
                      i < review.rating ? 'ri-star-fill text-primary-500' : 'ri-star-line text-foreground-300'
                    }`}
                  ></i>
                ))}
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {review.content}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}